export async function getResourcesBatched<TItem>(
  total: number,
  size: number,
  getBatch: (page: number, size: number) => Promise<TItem[]>,
  reporter?: (total: number, batchSize: number, progress: number) => void,
) {
  const batches = Math.ceil(total / size);

  const results: TItem[] = [];
  for (let i = 0; i < batches; i++) {
    const batch = await getBatch(i, size);
    results.push(...batch);
    reporter && reporter(total, batch.length, results.length);
  }

  return results;
}
